import React from 'react';
// import './ListItemControlButtons.less'
import { LIST_ITEM_CLASS_NAME } from './ListItem';
import { IconButton } from '../buttons/IconButton';

export interface IListItemControlButtonsProps {
  index: number;
  onRemove?: (index: number) => void;
  onEdit?: (index: number) => void;
  onMoveUp?: (index: number) => void;
  onMoveDown?: (index: number) => void;
  onShowActions?: (index: number, elem: HTMLElement) => void;
  buttonRef?: React.Ref<HTMLButtonElement>;
}

/**
 * Control buttons for list items, with standard behaviors for move up/down, edit, and remove.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function ListItemControlButtons(props: IListItemControlButtonsProps) {
  const removeHandler = () => props.onRemove && props.onRemove(props.index);
  const editHandler = () => props.onEdit && props.onEdit(props.index);
  const moveUpHandler = () => props.onMoveUp && props.onMoveUp(props.index);
  const moveDownHandler = () => props.onMoveDown && props.onMoveDown(props.index);
  const onShowActionsHandler = (elem: HTMLElement) => props.onShowActions && props.onShowActions(props.index, elem);
  return (
    <>
      {props.onMoveUp && (
        <IconButton
          title="Move Up"
          iconClassName={`${LIST_ITEM_CLASS_NAME}__up`}
          onClick={moveUpHandler}
          iconSize="small"
        />
      )}
      {props.onMoveDown && (
        <IconButton
          title="Move Down"
          iconClassName={`${LIST_ITEM_CLASS_NAME}__down`}
          onClick={moveDownHandler}
          iconSize="small"
        />
      )}
      {props.onEdit && (
        <IconButton
          title="Edit"
          iconClassName={`${LIST_ITEM_CLASS_NAME}__edit`}
          onClick={editHandler}
          iconSize="small"
        />
      )}
      {props.onRemove && (
        <IconButton
          title="Remove"
          iconClassName={`${LIST_ITEM_CLASS_NAME}__remove`}
          onClick={removeHandler}
          iconSize="small"
        />
      )}
      {props.onShowActions && (
        <IconButton
          title="More Actions"
          iconClassName={`${LIST_ITEM_CLASS_NAME}__actions`}
          onClick={e => onShowActionsHandler(e.currentTarget)}
          iconSize="small"
          ref={props.buttonRef}
        />
      )}
    </>
  );
}
